import React from "react";

function ProjectIntroduction() {
    return (
      <section id="introduction" className="intro-section">
        <div className="intro-container">
          <div className="section-spacer"></div>
          <div className="section-header">
            <h2 className="section-title">Precision in Nature Discovery</h2>
            <p className="section-subtitle">
              Advanced AI technology for 95% accurate data. Simplifying research across land, sea, and air,<br/>
              our secure cloud storage ensures access to precise information anytime, anywhere.
            </p>
          </div>
          <div className="video-wrapper">
            <iframe 
              src="https://www.youtube.com/embed/uCYREa2gmoE?si=8MKcKWzfewsBwjif" 
              title="YouTube video player" 
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
              allowFullScreen
              className="intro-video"
            ></iframe>
          </div>
        </div>
      </section>
    )
}
  
export default ProjectIntroduction
